/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeDialogDate } from "../../d-dialog-date";
import { DThemeWhiteDialogFitted } from "./d-theme-white-dialog-fitted";

export class DThemeWhiteDialogDate extends DThemeWhiteDialogFitted implements DThemeDialogDate {}
